import { render } from "./AddBlStep2.vue?vue&type=template&id=70d1f453&scoped=true&ts=true"
import script from "./AddBlStep2.vue?vue&type=script&lang=ts"
export * from "./AddBlStep2.vue?vue&type=script&lang=ts"

import "./AddBlStep2.vue?vue&type=style&index=0&id=70d1f453&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d1f453"]])

export default __exports__